import React, { useState } from 'react';
import { Image, Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useFormik } from "formik";
import * as Yup from "yup";

export const UploadDocumentModal = ({ uploadModal, uploadClose, isLoading, onDocSubmit, selectedDoc }) => {
    // const [dcfile, setDcFile] = useState(selectedDoc.URL || null);

    const initialValues = {
        type: selectedDoc.type || "",
        url: selectedDoc.URL || "",
        file: null,
    };

    const uploadDocSchema = Yup.object().shape({
        type: Yup.string().trim()
            .required('Required Field'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: uploadDocSchema,
        enableReinitialize: true,
        onSubmit: (values, { setErrors }) => {
            if (!values.file && !values.url) {
                return setErrors({ file: "Upload a document" });
            }
            onDocSubmit(values);
        },
    });
    const uploadDoc = (e) => {
        if (e.target.files && e.target.files.length) {
            formik.setFieldValue('url', URL.createObjectURL(e.target.files[0]))
            formik.setFieldValue('file', e.target.files[0])
        }
    };

    return (
        <Modal
            show={uploadModal}
            onHide={() => {
                formik.resetForm();
                uploadClose();
            }}
            centered
            className="def_modal delete_modal modal_400"
        >
            <Modal.Header closeButton>
                <Modal.Title className="fn_s_18 color_blk f-w-700">Upload Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form frmwtpddng" onSubmit={formik.handleSubmit}>
                    <div className="up_box">
                        <div className="row">
                            <div className="col-md-12 text-center subheader_filter">
                                <div className="form-group mr-3 mb-1">
                                    <select
                                        className="form-control wtblcar_v2 wtc_bl"
                                        name="type"
                                        {...formik.getFieldProps("type")}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="National Id">National Id</option>
                                        <option value="Driving License">Driving License</option>
                                    </select>
                                    {formik.touched.type && formik.errors.type ? (
                                        <div className="fv-plugins-message-container">
                                            <div className="fv-help-block">{formik.errors.type}</div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-md-12 text-center">

                                <div className="doc_u_btn">
                                    <input
                                        type="file"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={uploadDoc}
                                    />
                                    <label>Upload Document</label>
                                </div>
                                {formik.errors.file ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.file}</div>
                                    </div>
                                ) : null}


                                {formik.values.url && (
                                    <div className="enIconUploaded">
                                        {/* <button
                                            type="button"
                                            className="enCloseButton"
                                            onClick={() => setDcFile(null)}
                                        >
                                            <Image
                                                src={toAbsoluteUrl("/media/others/d_close.svg")}
                                                alt="uploadDoc"
                                                title="uploadDoc"
                                                fluid
                                            />
                                        </button> */}
                                        <Image
                                            src={formik.values.url}
                                            alt="icon"
                                            title="icon"
                                            className=""
                                            fluid
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-md-12 text-center mt-5">
                                <button type="submit" className="btn btn-def btn-defv4 uppercase" disabled={isLoading}>
                                    Submit
                                    {isLoading && <span className="ml-3 spinner spinner-white"></span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}